<template>
  <layout-default :hide-footer-mobile="true">
    <steps-header-outlet
      :current-step="2"
      extra-class="steps-component-payment-page"
    ></steps-header-outlet>
    <div
      class="step-3-content"
      data-aos="fade-left"
      data-aos-duration="1500"
      data-aos-once="true"
    >
      <div class="pdv-container">
        <div class="custom-padding">
          <div class="row">
            <div class="col">
              <h3 class="section-title">Revisa y confirma tus cursos</h3>
            </div>
          </div>
          <div class="row" id="affixContainer">
            <div class="col-md-6 col-xs-12">
              <div
                v-for="(student, index) in students"
                :key="index"
                class="checkout-card check-in-info-card"
              >
                <div class="main-info">
                  <div class="item">
                    <span class="item-head">Programa</span> <br />
                    <strong class="item-value">
                      {{ selectedPack.title }}</strong
                    >
                  </div>
                  <div class="item">
                    <span class="item-head">Nombre del estudiante</span> <br />
                    <strong class="item-value"
                      >{{
                        student.name +
                        " " +
                        student.fatherLastName +
                        " " +
                        student.lastName
                      }}
                    </strong>
                  </div>
                  <div class="item">
                    <span class="item-head">Sede</span> <br />
                    <strong class="item-value">
                      {{ student.selectedLocation.address }} *</strong
                    >
                  </div>
                  <div class="heading-info">
                    <span>Cursos</span> <br />

                    <div
                      class="item"
                      v-for="(detail, index) in selectedPack.PackDetails"
                      :key="index"
                    >
                      <strong
                        >{{ detail.Course.Subject.name }}
                        {{ detail.Course.pdvCode }}</strong
                      >
                      <p>
                        <template v-for="schedule in detail.Course.Schedules">
                          {{ schedule.dayOfWeek.substr(0, 3) }}
                          {{ schedule.startTime.replaceAll(":00", "") }} a
                          {{ schedule.endTime.replaceAll(":00", "") }} hs
                        </template>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="price-info">
                  <!--div class="header-total">
                    <span class="key">Total cursos</span>
                    <span  class="value"> $ 2.300.000 </span>
                  </div>
                  <div  class="descuento">
                      <span  >Desc. oferta (56%) </span>
                      <span> -$1.300.000</span>
                  </div-->
                  <div class="monto-total">
                    <span class="key"> Monto programa </span>
                    <strong>
                      * {{ selectedPack.priceOfert | moneyFormatter }}</strong
                    >
                  </div>
                </div>
              </div>

              <div class="note w-full d-flex">
                <div>
                  <img src="/images/featured/warning.svg" alt="warning" />
                </div>
                <div class="flex-1">
                  <div class="title-note">IMPORTANTE</div>
                  <p class="text-note">
                    * El monto obtenido en tu cotización corresponde al
                    <b>valor anual</b> de tu programa
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xs-12 position-relative d-md-block">
              <affix relative-element-selector="#affixContainer" class="">
                <div>
                  <abstract-check-in-info-outlet
                    @buttonClicked="saveOrderData"
                    @apllyCouponClicked="appllyCoupon"
                    @addCouponClicked="addCoupon"
                    @removeCoupon="removeCoupon"
                    :total="total"
                    :subTotal="subTotal"
                    :validCoupon="validCoupon"
                    :valorDescuentoCupon="valueCoupon"
                    :valorDescuento="valorDescuentoApi"
                    :precioSubTotal="precioSubTotalApi"
                  ></abstract-check-in-info-outlet>
                </div>
              </affix>
              <div class="only-mobileBlock margen-custom-total">
                <div>
                  <abstract-check-in-outlet
                    @buttonClicked="saveOrderData"
                    @apllyCouponClicked="appllyCoupon"
                    @addCouponClicked="addCoupon"
                    @removeCoupon="removeCoupon"
                    :total="total"
                    :subTotal="subTotal"
                    :validCoupon="validCoupon"
                    :valorDescuentoCupon="valueCoupon"
                    :valorDescuento="valorDescuentoApi"
                    :precioSubTotal="precioSubTotalApi"
                  ></abstract-check-in-outlet>
                </div>
              </div>
            </div>
            <!--a
              style="visibility:hidden;"
              ref="btnUnknowErrorModal"
              data-backdrop="static"
              data-keyboard="false"
              href=".unknow-error-modal"
              data-toggle="modal"
            ></a-->
          </div>
        </div>
      </div>

      <!--unknow-error-modal /-->
      <form
        id="webpayFormOulet"
        :action="webpay ? webpay.url : ''"
        method="post"
        class="hidden-form"
      >
        <input
          type="hidden"
          name="token_ws"
          :value="webpay ? webpay.token : ''"
        />
        <button type="submit">Enviar</button>
      </form>

      <div v-if="showModal" class="modal-intensive" id="modalIntensive">
        <div class="content realtive">
          <!--div class="header">
            <img src="/images/featured/close-circle-menu.svg" alt="close-circle-menu" class="btn-modal" @click="closeModal" /> 
          </div-->

          <img
            src="/images/featured/imageModalLoading.svg"
            alt="imageModalLoading"
            class="img-modal-loading"
          />
          <div class="text-content">
            <div class="d-flex justify-content-center mb-4">
              <img
                src="/images/featured/IconButtonRelod.svg"
                alt="IconButtonRelod"
              />
            </div>
            <h4 class="title-modal">
              Espera un momento mientras <br />
              procesamos tu solicitud
            </h4>
            <p class="title-modal">Esto puede demorar unos segundos.</p>
          </div>
        </div>
      </div>

      <div id="formsList" class="container position-relative">
        <div class="d-none alert-info">
          <div>
            <img src="/images/iconos/clock-white.svg" alt="" />
            <p>Tus cupos estarán asegurados por</p>
            <span>{{ quotasTimeRemaining | timeRemaining }}</span>
          </div>
        </div>

        <a
          style="visibility: hidden"
          ref="btnCancelPay"
          data-backdrop="static"
          data-keyboard="false"
          href=".cancel-pay-modal"
          data-toggle="modal"
        ></a>
        <a
          style="visibility: hidden"
          ref="btnSuccessfulFlowModal"
          data-backdrop="static"
          data-keyboard="false"
          href=".successful-flow-modal"
          data-toggle="modal"
        ></a>
        <a
          style="visibility: hidden"
          ref="btnSuccessModalWithCoupon"
          data-backdrop="static"
          data-keyboard="false"
          href=".success-modal-with-coupon"
          data-toggle="modal"
        ></a>
        <a
          style="visibility: hidden"
          ref="btnUnknowErrorModal"
          data-backdrop="static"
          data-keyboard="false"
          href=".unknow-error-modal"
          data-toggle="modal"
        ></a>
      </div>

      <error-pay-modal @onPay="tryToPayAgain" />
      <successful-flow-modal @onContinue="redirectToWebpay" />
    </div>
  </layout-default>
</template>

<script>
import moment from "moment";
import { mapState, mapActions } from "vuex";
import LayoutDefault from "@/layouts/Default";
//import StepsHeader from "@/components/StepsHeader";
//import AbstractCheckInInfo from "@/components/AbstractCheckInInfo";
import AbstractCheckInInfoOutlet from "@/components/AbstractCheckInInfoOutlet";
import ErrorPayModal from "@/components/modals/ErrorPayModal";
import SuccessfulFlowModal from "@/components/modals/SuccessfulFlowModal";

export default {
  data() {
    return {
      webpay: null,
      showModal: false,
      interval: null,
      total: null,
      discount: null,
      coupon: null,
      valueCoupon: 0,
      subTotal: 0,
      validCoupon: true,
      totalResponseApi: 1000,
      validCouponResponseAPi: false,
      valorDescuentoApi: 0,
      precioSubTotalApi: 0,
      rut: "",
    };
  },

  components: {
    LayoutDefault,
    //StepsHeader,
    AbstractCheckInInfoOutlet,
    ErrorPayModal,
    SuccessfulFlowModal,
  },
  computed: {
    ...mapState(["students", "quotasTimeRemaining"]),
    programSelectedTitle() {
      return "PSU " + this.$store.state.student.program;
    },
    selectedProgram() {
      return this.$store.state.selectedProgram;
    },
    selectedSubjects() {
      return this.$store.state.selectedSubjects;
    },
    selectedSubjectsWithCourses() {
      return this.$store.state.selectedSubjectsWithCourses;
    },
    selectedPack() {
      return JSON.parse(localStorage.getItem("pack"));
    },
    students() {
      return this.$store.state.students;
    },
    selectedCourses() {
      return this.$store.state.selectedCourses;
    },
  },
  methods: {
    ...mapActions([
      "setQuotasTimeRemaining",
      "clearCoursesNotAvailables",
      "setCoursesNotAvailables",
    ]),
    round(num, decimalPlaces = 2) {
      let newNum = num * 100;
      return Math.round(newNum);
    },
    tryToPayAgain() {
      this.accept = true;
      setTimeout(() => {
        this.$refs.payButton.click();
      }, 500);
    },
    discountSeconds() {
      const currentTime = moment(this.quotasTimeRemaining, "mm:ss").subtract(
        1,
        "second"
      );
      this.setQuotasTimeRemaining(currentTime.format("mm:ss"));
    },
    getPercentaje() {
      if (this.subTotal === 0) {
        return 0;
      } else {
        return Math.round(((this.subTotal - this.total) * 100) / this.subTotal);
      }
    },
    loadCourseQuote(cupon) {
      let orderId;
      if (localStorage.ordenID) {
        orderId = localStorage.ordenID;
      }
      let promesas = [];
      this.students.forEach((student) => {
        promesas.push(
          new Promise((resolve) => {
            let locationId = student.selectedLocation.id;
            let programId = student.program.id;
            let coursesIds;
            if (this.selectedProgram.isOnline) {
              coursesIds = this.selectedSubjectsWithCourses.map(
                (sub) => sub.courses[0].id
              );
            } else {
              coursesIds = student.selectedCourses
                .map((course) => course.id)
                .join(",");
            }
            this.rut = this.students[0].rut.replaceAll(".", "");
            let url = `/quote?locationId=${locationId}&programId=${programId}&coursesIds=${coursesIds}&studentId=${student.id}&orderId=${orderId}`;
            if (cupon) {
              url += `&coupon=${cupon}&rut=${this.rut}`;
            }
            this.Axios.get(url)
              .then((response) => {
                let info = {
                  student,
                  append: { prices: response.data },
                };
                this.totalResponseApi = response.data.precioTotal;
                this.validCouponResponseAPi = response.data.validCupon;
                this.precioSubTotalApi = response.data.precioSubTotal;
                this.valorDescuentoApi = response.data.valorDescuento;
                if (cupon) {
                  this.validCoupon = response.data.validCupon;
                }
                if (response.data.validCupon) {
                  this.coupon = cupon;
                  this.valueCoupon = response.data.valorDescuentoCupon;
                } else {
                  this.coupon = null;
                  this.valueCoupon = 0;
                }
                if (this.subTotal === 0) {
                  //this.subTotal = response.data.precioTotal;
                  this.subTotal = parseInt(this.selectedPack.priceOfert, 10);
                }
                //falta validar si cupon es valid
                this.$store.dispatch("addInfoToStudent", info);
                resolve();
              })
              .catch((err) => {
                if (err.response.data.name === "QuoteFailed") {
                  this.$refs.btnUnknowErrorModal.click();
                }
              });
          })
        );
      });
      try {
        Promise.all(promesas).then(() => {
          this.setTotal();
          this.$store.dispatch("setStudentsWithPrices");
        });
      } catch (err) {
        alert("ji");
      }
    },
    getSchedule(hoursPerDay) {
      let days = "";
      if (hoursPerDay.length == 1) {
        days =
          hoursPerDay[0].day +
          " " +
          hoursPerDay[0].startTime.slice(0, -3) +
          " a " +
          hoursPerDay[0].endTime.slice(0, -3);
      } else if (hoursPerDay.length == 2) {
        if (
          hoursPerDay[0].startTime.slice(0, -3) ==
            hoursPerDay[1].startTime.slice(0, -3) &&
          hoursPerDay[0].endTime.slice(0, -3) ==
            hoursPerDay[1].endTime.slice(0, -3)
        ) {
          days =
            hoursPerDay[0].day +
            " y " +
            hoursPerDay[1].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3);
        } else {
          days =
            hoursPerDay[0].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3) +
            " y " +
            hoursPerDay[1].day +
            " " +
            hoursPerDay[1].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[1].endTime.slice(0, -3);
        }
      } else if (hoursPerDay.length == 3) {
        if (
          hoursPerDay[0].startTime.slice(0, -3) ==
            hoursPerDay[1].startTime.slice(0, -3) &&
          hoursPerDay[0].endTime.slice(0, -3) ==
            hoursPerDay[1].endTime.slice(0, -3) &&
          hoursPerDay[0].startTime.slice(0, -3) !=
            hoursPerDay[2].startTime.slice(0, -3)
        ) {
          days =
            hoursPerDay[0].day +
            " y " +
            hoursPerDay[1].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3) +
            " y " +
            hoursPerDay[2].day +
            " " +
            hoursPerDay[2].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[2].endTime.slice(0, -3);
        } else if (
          hoursPerDay[0].startTime.slice(0, -3) ==
            hoursPerDay[2].startTime.slice(0, -3) &&
          hoursPerDay[0].endTime.slice(0, -3) ==
            hoursPerDay[2].endTime.slice(0, -3) &&
          hoursPerDay[0].startTime.slice(0, -3) !=
            hoursPerDay[1].startTime.slice(0, -3)
        ) {
          days =
            hoursPerDay[0].day +
            " y " +
            hoursPerDay[2].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3) +
            " y " +
            hoursPerDay[1].day +
            " " +
            hoursPerDay[1].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[1].endTime.slice(0, -3);
        } else if (
          hoursPerDay[2].startTime.slice(0, -3) ==
            hoursPerDay[1].startTime.slice(0, -3) &&
          hoursPerDay[2].endTime.slice(0, -3) ==
            hoursPerDay[1].endTime.slice(0, -3) &&
          hoursPerDay[0].startTime.slice(0, -3) !=
            hoursPerDay[2].startTime.slice(0, -3)
        ) {
          days =
            hoursPerDay[2].day +
            " y " +
            hoursPerDay[1].day +
            " " +
            hoursPerDay[2].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[2].endTime.slice(0, -3) +
            " y " +
            hoursPerDay[0].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3);
        } else if (
          hoursPerDay[0].startTime.slice(0, -3) ==
            hoursPerDay[1].startTime.slice(0, -3) &&
          hoursPerDay[0].endTime.slice(0, -3) ==
            hoursPerDay[1].endTime.slice(0, -3) &&
          hoursPerDay[0].startTime.slice(0, -3) ==
            hoursPerDay[2].startTime.slice(0, -3) &&
          hoursPerDay[0].endTime.slice(0, -3) ==
            hoursPerDay[2].endTime.slice(0, -3)
        ) {
          days =
            hoursPerDay[0].day +
            ", " +
            hoursPerDay[1].day +
            " y " +
            hoursPerDay[2].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3);
        } else {
          days =
            hoursPerDay[0].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3) +
            ", " +
            hoursPerDay[1].day +
            " " +
            hoursPerDay[1].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[1].endTime.slice(0, -3) +
            " y " +
            hoursPerDay[2].day +
            " " +
            hoursPerDay[2].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[2].endTime.slice(0, -3);
        }
      }
      return days;
    },
    async saveOrderData() {
      this.showModal = true;
      let fullOrderStudentsData = this.students.map((student) => {
        let coursesIds;

        const packDetails = this.selectedPack.PackDetails;
        coursesIds = packDetails.map((detail) => detail.Course.id);

        return {
          locationId: student.selectedLocation.id,
          programId: student.program.id,
          coursesIds,
          studentId: student.id,
        };
      });

      this.students[0] = {
        ...this.students[0],
        packId: this.selectedPack.id,
      };

      let sessionState = { students: this.students };

      const newFullOrder = {
        ...this.$store.state.fullOrder,
        orderDetails: fullOrderStudentsData,
        coupon: this.coupon,
        rut: this.rut,
        sessionState: JSON.stringify(sessionState),
        isOulet: true,
        amountPack: parseInt(this.selectedPack.priceOfert, 10),
      };

      localStorage.removeItem("fullOrder");
      localStorage.setItem("fullOrder", newFullOrder);
      this.startTransaction(newFullOrder);
    },
    async startTransaction(newFullOrder) {
      //this.showModal = true;

      try {
        const { data: order } = await this.Axios.put("/orders", newFullOrder, {
          withCredentials: true,
        });

        this.webpay = {
          url: order.url,
          token: order.token,
        };

        //validar que si es = muestre otro modal

        let promises = this.students.map((student) => {
          return this.Axios.put(`/students/${student.id}`, {
            financingPartyId: order.financingPartyId,
            caretakerId: order.caretakerId,
          });
        });
        await Promise.all(promises);

        if (order.url == null && order.token == null) {
          this.showModal = false;
          this.$refs.btnSuccessModalWithCoupon.click();
        } else {
          this.showModal = false;
          this.$refs.btnSuccessfulFlowModal.click();
        }
      } catch (err) {
        console.log("erro saveOrderData", err);

        if (err.response.data.name === "CourseNotAvailable") {
          this.showModal = false;
          this.setCoursesNotAvailables(err.response.data.coursesNotAvailables);
        } else if (err.response.data.name === "UnknowError") {
          this.showModal = false;
          this.$refs.btnUnknowErrorModal.click();
        }
      }
    },
    async appllyCoupon(coupon) {
      this.loadCourseQuote(coupon);
    },
    addCoupon() {
      this.validCoupon = true;
    },
    setTotal() {
      if (this.validCouponResponseAPi && this.totalResponseApi === 0) {
        //this.total = this.totalResponseApi
        this.total = parseInt(this.selectedPack.priceOfert);
      } else {
        //this.total = this.$store.state.students
        this.total = this.selectedPack.priceOfert
          .map((student) => student.prices.precioTotal)
          .reduce(
            (previousValue, currentValue) => previousValue + currentValue
          );
      }
    },

    goToNextStep() {
      this.$router.push({ name: "Step4" });
    },
    addOtherStudent() {
      this.$store.dispatch("showBackpack").then(() => {
        this.$router.push({ name: "BuyOtherProgram" });
      });
    },
    removeCoupon() {
      this.coupon = null;
      this.valueCoupon = 0;
      this.validCoupon = true;
      this.loadCourseQuote(null);
    },
    redirectToWebpay() {
      document.getElementById("webpayFormOulet").submit();
    },
  },

  async mounted() {
    this.loadCourseQuote(null);
    this.total = parseInt(this.selectedPack.priceOfert, 10);

    await this.$store.dispatch("clearSelectedSubjects");
    this.selectedSubjectsWithCourses.forEach((subject) => {
      let newSubject = {
        createdAt: subject.createdAt,
        hasMention: subject.hasMention,
        id: subject.id,
        name: subject.name,
        pdvId: subject.pdvId,
        updatedAt: subject.updatedAt,
        courses: [],
        subject: {
          createdAt: subject.createdAt,
          hasMention: subject.hasMention,
          id: subject.id,
          name: subject.name,
          pdvId: subject.pdvId,
          updatedAt: subject.updatedAt,
        },
      };
      this.$store.dispatch("addSubject", newSubject);
    });

    //this.$store.dispatch("clearSelectedCourses");
    let arrayCourses = [];
    this.selectedCourses.forEach((course) => {
      const newCourse = {
        courseId: course.id,
        hour: course.hour,
        days: [],
        subjectName: course.Subject.name,
        coursePdvId: course.pdvId,
        coursePdvCode: course.pdvCode,
        subjectId: course.subjectId,
      };
      arrayCourses.push(newCourse);
    });

    this.$store.dispatch("clearSelectedCourses");
    arrayCourses.forEach((course) => {
      this.$store.dispatch("saveCourseSelected", course);
    });

    /*this.$store.dispatch("clearSelectedSubjects").then(() => {
      newSubject.forEach(s => {
        this.$store.dispatch("addSubject", s);
      })
    })*/

    /*await this.$store.dispatch("clearCoursesNotAvailables");
    await this.$store.dispatch("addInfoToFullOrder", {
      // sessionState: JSON.stringify(sessionState)
      sessionState: JSON.stringify(copySesion)
    });*/
    await this.Axios.put(
      "/orders",
      { ...this.$store.state.fullOrder, financingParty: null },
      { withCredentials: true }
    );

    const zoomScript = document.createElement("script");
    zoomScript.src = "https://us01ccistatic.zoom.us/us01cci/web-sdk/zcc-sdk.js";
    zoomScript.setAttribute("data-apikey", "G4nAX1GiTf6ib-GJAcV4Qw");
    zoomScript.setAttribute("data-env", "us01");
    zoomScript.async = true;
    document.body.appendChild(zoomScript);
  },

  beforeDestroy() {
    const script = document.querySelector('script[src="https://us01ccistatic.zoom.us/us01cci/web-sdk/zcc-sdk.js"]');
    if (script) {
      script.remove();  // Elimina el script al salir de la página
    }
  },

  beforeDestroy() {
    //clearInterval(this.interval);
  },
  filters: {
    timeRemaining(time) {
      return moment(time, "mm:ss").format("mm’ ss’’");
    },
  },

  created() {
    this.Axios.get("/dashadmin/infogeneral").then((response) => {
      this.discount = response.data[0].discount;
    });
  },
};
</script>

<style scoped lang="scss">
.margen-custom-total {
  @media (max-width: 768px) {
    margin-top: 40px;
    margin-right: -24px !important;
    margin-left: -24px !important;
  }
}

.boton-new-primario {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background-color: $morado50;
  border: solid 4px $neutralwhite;
  color: $neutralwhite;
  &:hover {
    background-color: $morado30;
  }
  &:active {
    background-color: $morado90;
  }
  &:focus {
    background-color: $morado50;
    border: solid 4px grey;
  }
  &:disabled {
    background-color: #5924661a;
  }

  &.boton-new-largo {
    padding: 0 32px;
    height: 60px;
    width: auto;
    font-size: 20px;
    line-height: 28px;
  }
  &.boton-new-mediano {
    padding: 0 24px;
    height: 48px;
    width: auto;
    font-size: 16px;
    line-height: 18px;
  }
  &.boton-new-pequeno {
    padding: 0 16px;
    height: 32px;
    width: auto;
    font-size: 14px;
    line-height: 22px;
  }

  img {
    margin-right: 16px;
  }
}

.price-info {
  border-top: 2px dotted #cacbce;

  .header-total {
    padding: 20px 0px 10px 0px;
  }

  .descuento {
    color: green;
    padding: 8px 0px 10px 0px;
  }

  .monto-total {
    border-top: 1px solid #cacbce;
    padding: 20px 0 20px 0;
    display: flex;
    justify-content: space-between;
  }
}
.seccion-separator {
  width: 100%;
  @media (max-width: 768px) {
    margin-top: 32px;
  }
  @media (min-width: 769px) {
    margin-top: 40px;
  }
}

.imagen-pensar {
  @media (min-width: 769px) {
    margin-top: -170px;
  }
}

.w-accordion-custom {
  @media (max-width: 768px) {
    width: 100%;
  }
  @media (min-width: 769px) {
    width: 352px;
  }
}

.custom-padding {
  @media (max-width: 768px) {
    padding: 0 24px;
  }
  @media (min-width: 769px) {
    padding: 0 76px;
  }
}

.step-3-content {
  @media (min-width: 769px) {
    padding-bottom: 48px;
  }

  .section-title {
    color: $neutralBlack;
    font-family: "Poppins-Bold", sans-serif;
    padding-top: 59px;
    margin-top: 4rem;
    font-style: normal;
    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 28px;
    }
    @media (min-width: 769px) {
      font-size: 32px;
      line-height: 42px;
    }
  }

  .vue-affix {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  h3 {
    font-size: 18px;
    line-height: 26px;
    @include alternative-regular;
    margin-bottom: 15px;
    @include media-breakpoint-down(sm) {
      margin-top: 20px;
    }
  }
}
.img-modal-loading {
  position: absolute;
  right: 8px;
  bottom: 20px;
  height: 80%;

  @media (max-width: 768px) {
    display: none;
  }
}
.title-modal {
  text-align: center;
  margin: 10px;
}

div .underline-link {
  margin-left: 105px;
}

.alert-info {
  display: flex;
  align-items: center;
  background: $red-2;
  padding: 5px 25px;
  position: absolute;
  top: -45px;
  right: 15px;

  img {
    width: 25px;
    @include media-breakpoint-down(sm) {
      width: 22px;
    }
  }

  p {
    color: #fff;
    margin-bottom: 0;
    font-size: 14px;
    @include alternative-light-regular;
    margin: 0 5px;
  }

  span {
    color: #fff;
    font-size: 20px;
    @include alternative-medium-regular;
    @include media-breakpoint-down(sm) {
      font-size: 18px;
    }
  }

  @include media-breakpoint-down(sm) {
    width: calc(100% + 30px);
    position: static;
    right: unset;
    top: unset;
    margin-left: -15px;
    margin-right: -15px;
    justify-content: center;
    padding: 5px 4px;
  }
}

.checkout-card {
  border-radius: 8px;
  border: 1px solid $neutralBlack;
  padding: 16px;
  margin-bottom: 30px;
}

.check-in-info {
  .check-in-info-card {
    border-radius: 8px;
    border: 1px solid $neutralBlack;
    padding: 16px;
    margin-bottom: 30px;

    .number-student-tag {
      letter-spacing: 2px;
      font-size: 12px;
      line-height: 22px;
      margin-bottom: 22px;
      @include alternative-regular;
      color: $gray;
      display: inline-block;
    }

    ul {
      padding-left: 0;
      margin-bottom: 0;

      li {
        display: flex;
        justify-content: space-between;
        list-style: none;
        margin-bottom: 16px;

        &:last-child {
          margin-bottom: 0;
        }

        span {
          font-size: 14px;
          @include alternative-light-regular;

          .index-number {
            font-size: 16px;
            @include alternative-medium-regular;
          }

          &:last-child {
            text-align: right;
          }
        }

        &.heading-info {
          span {
            color: $neutral70;
            font-family: Poppins;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: 22px;
          }
        }

        &.promo-info-item {
          span {
            @include media-breakpoint-down(sm) {
              font-size: 12px;
            }
            color: $green;
            font-size: 16px;
            line-height: 5px;
            @include alternative-medium-regular;
          }
        }
      }
    }

    .heading-info {
      span {
        color: $neutral70;
        font-family: "Poppins-Bold", sans-serif;
        font-size: 14px;
        font-style: normal;
        line-height: 22px;
      }
    }

    .main-info {
      padding-bottom: 30px;
      margin-bottom: 16px;
      border-bottom: 2px dashed #cacbce;

      .item {
        display: flex;
        flex-direction: column;
        margin-bottom: 12px;

        .item-head {
          color: #4e4f55;
          font-family: "Poppins-Regular", sans-serif;
          font-size: 14px;
          font-style: normal;
          line-height: 22px;
        }

        .item-value {
          color: $neutralBlack;
          font-family: "Poppins-Medium", sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 24px;

          span {
            color: $neutralBlack;
            font-family: "Poppins-Medium", sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
          }
        }
      }

      .info-item {
        margin-bottom: 10px;
      }
      .info-item > span:last-child {
        @include alternative-regular;
        color: #000;
      }
    }

    .coupon-info {
      padding-bottom: 16px;
      margin-bottom: 16px;
      border-bottom: 0.5px solid $gray;

      .amounts {
        .amount-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;

          .key {
            color: $succes80;
            font-family: "Poppins-Regular", sans-serif;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
          }

          .value {
            color: $succes80;
            font-family: "Poppins-Medium", sans-serif;
            font-size: 12px;
            font-style: normal;
            line-height: 16px;
          }
        }
      }
    }

    .amount-discounts {
      padding-top: 1rem;
      border-top: 2px dashed #cacbce;
    }

    .final-price-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .key {
        color: $neutralBlack;
        font-family: "Poppins-Regular", sans-serif;
        @media (max-width: 768px) {
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;
        }
        @media (min-width: 769px) {
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;
        }
      }
      .value {
        color: $neutral70;
        font-family: "Poppins-Bold", sans-serif;
        text-align: right;
        @media (max-width: 768px) {
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: 28px;
        }
        @media (min-width: 769px) {
          font-size: 16px;
          font-style: normal;
          font-weight: 700;
          line-height: 24px;
        }
      }
    }
  }
}

.note {
  border-radius: 8px;
  border: 1px solid #f1c469;
  background: #fffaf0;
  box-sizing: border-box;
  padding: 12px 16px;
  margin-top: 25px;
  img {
    margin-right: 12px;
  }
}

.note-mobile {
  display: none;
  border-radius: 8px;
  border: 1px solid #f1c469;
  background: #fffaf0;
  box-sizing: border-box;
  padding: 20px;
  @include alternative-regular;
  width: 100%;
  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
}

.title-note {
  color: #966a11;
  font-family: "Poppins-Medium", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.text-note {
  color: #966a11;
  font-family: "Poppins-Regular", sans-serif;
  font-size: 14px;
  font-style: normal;
  line-height: 22px;

  span {
    font-family: "Poppins-Bold", sans-serif;
  }
}

.vue-affix {
  flex-direction: column !important;
  align-items: flex-end !important;
}

.hidden-form {
  position: absolute;
  visibility: hidden;
}
</style>
